import { render, staticRenderFns } from "./SwitchItem.vue?vue&type=template&id=27f6ec68&scoped=true&"
import script from "./SwitchItem.vue?vue&type=script&lang=js&"
export * from "./SwitchItem.vue?vue&type=script&lang=js&"
import style0 from "./SwitchItem.vue?vue&type=style&index=0&id=27f6ec68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6ec68",
  null
  
)

export default component.exports